var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 17.578,
    viewBox: "0 0 26.5 17.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        fill: #7d7d7d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11290",
    "data-name": "Group 11290",
    transform: "translate(-632.75 -4122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8043",
    "data-name": "Path 8043",
    className: "cls-1",
    d: "M16.325,0H25V13.571H0V0H9.108",
    transform: "translate(633.5 4124.143)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    className: "cls-2",
    width: 15.714,
    height: 4.643,
    transform: "translate(638.143 4126.768)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1067",
    "data-name": "Line 1067",
    className: "cls-1",
    x2: 21.429,
    transform: "translate(635.286 4133.504)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2205",
    "data-name": "Ellipse 2205",
    className: "cls-3",
    cx: 1.964,
    cy: 1.964,
    r: 1.964,
    transform: "translate(644.036 4122)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11288",
    "data-name": "Group 11288",
    transform: "translate(635.464 4138.828)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1073",
    "data-name": "Line 1073",
    className: "cls-1",
    x2: 3.214,
    transform: "translate(17.857)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1478",
    "data-name": "Line 1478",
    className: "cls-1",
    x2: 3.214
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11289",
    "data-name": "Group 11289",
    transform: "translate(637.964 4135.415)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1072",
    "data-name": "Line 1072",
    className: "cls-1",
    x2: 1.429,
    transform: "translate(14.286)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1479",
    "data-name": "Line 1479",
    className: "cls-1",
    x2: 1.429,
    transform: "translate(10.714)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1480",
    "data-name": "Line 1480",
    className: "cls-1",
    x2: 1.429,
    transform: "translate(7.143)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1481",
    "data-name": "Line 1481",
    className: "cls-1",
    x2: 1.429,
    transform: "translate(3.571)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1482",
    "data-name": "Line 1482",
    className: "cls-1",
    x2: 1.429
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvp);
export default __webpack_public_path__ + "static/media/avp.129547729bbeef3daed20db53f0dc719.svg";
export { ForwardRef as ReactComponent };